/* eslint-disable */

// CART
// class is used to handle the CART page of course
// since it has been redesigned and stuff...
//
import $ from "jquery";
import "jquery-blockui";

let self;

export class WC_Cart {

  constructor() {
    self = this;

    // is the Shop element even here?
    if (!$('.woocommerce').length > 0) return;

    // Update the cart 'automatically' on item count change
    let timeout;


    jQuery( function( $ ) {
      $('div.woocommerce')
        .on('change', 'input.qty', function () {
          if (timeout !== undefined) clearTimeout(timeout);
          if ($(this)
            .val() === "") return;
          timeout = setTimeout(function () {
            $("[name='update_cart']")
              .trigger("click");
          }, 500);
        });


      $(document.body)
        .on('click', 'button.down', function (e) {
          e.preventDefault();

          let item_quantity_field = $(this)
            .parent('.number-input')
            .find('input.qty');

          // enable the update button so it is 'clickable'
          $('.woocommerce-cart-form :input[name="update_cart"]')
            .prop('disabled', false)
            .attr('aria-disabled', false);

          // Update the value
          let count = parseInt(item_quantity_field.val());
          item_quantity_field.val(count - 1)
            .change();
        });

      $('.woocommerce')
        .on('click', 'button.plus', function (e) {
          e.preventDefault();

          let item_quantity_field = $(this)
            .parent('.number-input')
            .find('input.qty');

          // enable the update button so it is 'clickable'
          $('.woocommerce-cart-form :input[name="update_cart"]')
            .prop('disabled', false)
            .attr('aria-disabled', false);

          // Update the value
          let count = parseInt(item_quantity_field.val());
          item_quantity_field.val(count + 1)
            .change();
        });



      // on showing / hiding discount code
      $(document.body)
        .on('click', '.order-discount a', function (e) {
          e.preventDefault();
          // adjust arrow
          const fa_icon = $('.order-discount a i');
          if (fa_icon.hasClass('fa-angle-down')) {
            fa_icon.removeClass('fa-angle-down')
              .addClass('fa-angle-up');
          } else {
            fa_icon.removeClass('fa-angle-up')
              .addClass('fa-angle-down');
          }


          // show / hide the form
          $('.discount-input')
            .toggle();
        });

      // on entering discount code
      $(document.body)
        .on('input', '.order_custom_discount', function (e) {

          const discount_button = $('.check_discount');

          if ($(this)
            .val()) {
            discount_button
              .addClass('green')
              .prop('disabled', false)
              .attr('aria-disabled', false);
          } else {
            discount_button
              .removeClass('green')
              .prop('disabled', true)
              .attr('aria-disabled', true);
          }
        });

      // check discount on enter
      $(document.body)
        .on('keypress', '.order_custom_discount', function (e) {
          let code = e.keyCode || e.which;
          if (code === 13) {
            self.sendDiscount($('.check_discount'));

          }
        });


      // on check discount code
      $(document.body)
        .on('click', '.check_discount', function (e) {
          e.preventDefault();

          self.sendDiscount(this);

        });

      // On adding add-on product
      $(document.body)
        .on('click', 'a.addon_button', function (e) {
          e.preventDefault();

          self.addAddon(this);
        });

      // Show modal for date overlap message
      $(document.body)
        .on('click', '.wc-proceed-to-checkout a.checkout-button', function (e) {
          if ($('#date_overlap_message').length) {
            e.preventDefault();
            $('#date_overlap_message')
              .modal('show');
          }
        });

      // Disabled. Enable if you need to again.
      //// Change payment button text with herexamens
      //$(function(){
      //  if ($('.product_title:contains("Herexamentraining")').length) {
      //    $('.payment-btn-txt').html( 'Reservering bevestigen' );
      //  }
      //});


      // Enable the checkout button when the checkbox is selected
      $(document.body)
        .on('change', '#date_overlap_check', function() {
          if(this.checked) {
            $('.to-checkout a').removeClass('disabled-link');
          } else {
            $('.to-checkout a').addClass('disabled-link');
          }
        });

      // hide location in cart review if examenboost with price of 69,00
      $(document).ready(function(){
        if ($('.woocommerce-Price-amount:contains("69,00")').length) { // check if this exists
          $('.training_item_wrapper p:first-of-type').hide();
          // hide this
        }
      });

      // vmbo tl Examenboost
      $(document).ready(function(){
        let vmbo = $('section[id="84153"]');
        //$('<span>Lyceo Examenboost</span>').prependTo('.product-card-title:first');
        vmbo.next('section').hide();
        vmbo.find('.cart-adress').text('Lyceo Examenboost Online');

      });
      // havowa Examenboost
      $(document).ready(function(){
        let havowa = $('section[id="84154"]');
       // $('<span>Lyceo Examenboost</span>').prependTo('.product-card-title:first');
        havowa.next('section').hide();
        havowa.find('.cart-adress').text('Lyceo Examenboost Online');

      });
      // havowb Examenboost
      $(document).ready(function(){
        let havowb = $('section[id="84155"]');
        //$('<span>Lyceo Examenboost</span>').prependTo('.product-card-title:first');
        havowb.next('section').hide();
        havowb.find('.cart-adress').text('Lyceo Examenboost Online');

      });
      // vwowa Examenboost
      $(document).ready(function(){
        let vwowa = $('section[id="84151"]');
        //$('<span>Lyceo Examenboost</span>').prependTo('.product-card-title:first');
        vwowa.next('section').hide();
        vwowa.find('.cart-adress').text('Lyceo Examenboost Online');
      });
      // vwowb Examenboost
      $(document).ready(function(){
        let vwowb = $('section[id="84152"]');
        vwowb.next('section').hide();
        vwowb.find('.cart-adress').text('Lyceo Examenboost Online');
      });

    });

  }

  /**
   * Make the POST call and add the given add-on data to the cart
   *
   * @param data
   */
  addAddon(data) {

    // add the complete dataset (data attributes),
    // since some of the variables are dynamic
    // and their names are unknown here.
    let dataset = $(data)
      .data();

    // Add these again, since the $.data() somehow doesnt add them in the correct manner.
    $.extend(dataset, {
      'add-to-cart':   $(data)
        .data('add-to-cart'),
      'update-bundle': $(data)
        .data('update-bundle'),
    });

    // set a visual spinner
    $(data).html('<span id="loading"></span>');

    // Block the cart for further action during AJAX
    $('.main-content').block({
      message:    null,
      overlayCSS: {
        background: '#fff',
        opacity:    0.6
      }
    });

    $.ajax({
       url:      ajax_link,
       method:   'POST',
       data:     {
         action:  'add_addon_to_product',
         dataset: dataset,
         nonce:   ajax_nonce
       },
       dataType: 'json'
     })
     .done(
       function (data, status) {
         location.reload();
       });

    /**
     * Not so nice, but oke...
     * first AJAX call is a call to get the current cart items for this add-on product
     *
     * we need all added products from the cart, for the second call, to have
     * one 'complete' call to update the bundled
     * products and ALL items that are added to it
     *
     */
    $.ajax({
      url:      ajax_link,
      method:   'POST',
      data:     {
        action:  'add_addon_to_product',
        dataset: dataset,
        nonce:   ajax_nonce
      },
      dataType: 'json'
    })
      .done(
        function (data, status) {
          // with the updated dataset,
          // now make the actual $_POST call to add the product(s) to the bundle
          $.post(ajax_link,
            data.data,
            function (data, status) {
              location.reload();
            });
        });
  }

  /**
   *
   * @param button
   */
  sendDiscount(button) {

    // get the given discount code
    let $discount_code = $('.order_custom_discount')
      .val();

    // Remove optional old error message
    $('.discount_input_err_msg')
      .html('');

    // set a visual spinner
    $(button)
      .html('<span id="loading"></span>');

    // check with backend
    self.fetchDiscountResults($discount_code);

  }

  /**
   * Ajax call to backend
   * that will call upon the gods from Skoleo
   * to receive their blessing
   * or not...
   *
   * @param $discount_code
   * @returns {JQuery.jqXHR}
   */
  fetchDiscountResults($discount_code) {

    return $.ajax({
      url:      ajax_link,
      method:   'POST',
      data:     {
        action:        'get_discount_results',
        discount_code: $discount_code,
        nonce:         ajax_nonce
      },
      dataType: 'json',
      success:  data => self.fetchDiscountSuccess(data),
      fail:     () => self.fetchDiscountFail(),
    });

  }

  /**
   * When a successful call, check if there is an actual amount returned
   *
   * @param data
   */
  fetchDiscountSuccess(data) {

    // Reset a visual spinner
    $('.check_discount')
      .html('Voeg toe');

    // Open the update cart button again
    $('.woocommerce-cart-form :input[name="update_cart"]')
      .prop('disabled', false)
      .attr('aria-disabled', false);

    // if no amount is received, show red and err msg
    if (!data.discount_amount) {
      $('input.order_custom_discount')
        .css('border', '2px solid red');

      $('.discount_input_err_msg')
        .html(data.error_message);

    } else {
      // else update the cart to show the updated total
      // enable the update button so it is 'clickable'
      $('.woocommerce-cart-form :input[name="update_cart"]')
        .trigger("click");
    }


  }

  fetchDiscountFail(data) {

    // set a visual spinner
    $('.check_discount')
      .html('Voeg toe');

    // Open the update cart button again
    $('.woocommerce-cart-form :input[name="update_cart"]')
      .prop('disabled', false)
      .attr('aria-disabled', false);

    // Show red border
    $('input.order_custom_discount')
      .css('border', '2px solid red');

    // Show err message
    $('.discount_input_err_msg')
      .html(data.error_message);
  }

}
